import * as yup from 'yup';

export const UNIDADES_REPUESTO = [
  { label: 'Unidad', value: 'un' },
  { label: 'Litro', value: 'lt' },
  { label: 'Mililitro', value: 'ml' },
  { label: 'Centimetro cubico', value: 'cc' },
  { label: 'Kilogramo', value: 'kg' },
  { label: 'Gramo', value: 'g' },
  { label: 'Metro', value: 'm' },
  { label: 'Centimetro', value: 'cm' },
  { label: 'Par', value: 'par' },
  { label: 'Caja', value: 'caja' },
];

export const diagnoReparacionSchema = yup.object().shape({
  diagnostico: yup.string().nullable(),
  recomendado: yup.string().nullable(),
  realizado: yup.string().nullable(),
  obs_mecanico: yup.string().nullable(),

  repuestos: yup.array().of(
    yup.object().shape({
      nombre: yup.string().required('El nombre del repuesto es obligatorio'),
      cantidad: yup
        .number()
        .typeError('Cantidad inválida')
        .positive('Debe ser mayor a 0')
        .required('La cantidad es obligatoria'),
      unidad: yup
        .string()
        .oneOf(UNIDADES_REPUESTO.map((u) => u.value), 'Selecciona una unidad válida')
        .required('Selecciona la unidad'),
    })
  ),
});